import React from 'react'
import { useTranslation } from 'react-i18n-lite'
import { useFilterFieldsContext } from '../../context'
import { FirstElement } from './GroupControls.styles'

const AreaLineTitle = () => {
  const { t } = useTranslation()
  const { styling } = useFilterFieldsContext()
  const { navigationSliderColor } = styling

  return (
    <FirstElement color={navigationSliderColor}>
      {t('report.filter-area.filter-head.filter-group')}
    </FirstElement>
  )
}

export default AreaLineTitle
